export default __webpack_public_path__ + "static/media/Metamask.c09c031b.png";